var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkEcharts"},[_c('div',{staticClass:"graphContainer"},[_c('div',{ref:"graphChart",staticClass:"graphChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }